export const SERVICES_PAGE_KEY = "services_client";

export const SERVICES_HERO_IMAGE = "images/services_background.png";

// Keep in sync with web_admin/src/views/pages/PageBuilder/sectionSchemas.js.
// Empty fonts mean "keep the site fonts", so nothing changes until an admin picks one.
export const DEFAULT_SERVICES_LAYOUT = {
  theme: {
    headingFont: "",
    bodyFont: "",
    primaryColor: "#FF7F26",
  },
  sections: [
    {
      id: "hero",
      type: "servicesHero",
      visible: true,
      style: {},
      props: {
        heading: "Creative Services For Your Next Project",
        subtext:
          "From video production and photography to design, voice-over and music, pick the service you need and work directly with KUVUMA creators who specialise in it.",
        searchPlaceholder: "Search services, e.g. editing",
        searchButton: "Search",
        promptText: "Not sure which service you need?",
        linkText: "Post an opportunity",
        promptSuffix: "and let creators come to you",
        bgImage: SERVICES_HERO_IMAGE,
      },
    },
    {
      // Step icons are fixed by position; only the text changes.
      id: "steps",
      type: "servicesSteps",
      visible: true,
      style: {},
      props: {
        steps: [
          {
            title: "Pick a service",
            text: "Browse categories like video production, photography, design, voice-over and music.",
          },
          {
            title: "Compare creators",
            text: "See who offers that service, review their portfolios and shortlist the right fit.",
          },
          {
            title: "Hire with confidence",
            text: "Agree on the brief, work directly with your creator and pay securely through KUVUMA.",
          },
        ],
      },
    },
    {
      id: "categories",
      type: "servicesCategories",
      visible: true,
      style: {},
      props: {
        heading: "Browse services by category",
        subtext:
          "Choose a category to see the creators who offer it. Review their portfolios and experience, then contact the ones that fit your brief.",
        linkLabel: "Browse creator",
      },
    },
    {
      id: "cta",
      type: "servicesCta",
      visible: true,
      style: {},
      props: {
        heading: "Can't find the service you need?",
        text: "Post an opportunity describing your project and let creators apply with their portfolios, or talk to our team and we'll point you to the right people.",
        primaryButton: "Post an Opportunity",
        secondaryButton: "Contact Us",
      },
    },
  ],
};
